const createPdfComponents = require('../pdf/components.js');

angular.module('pdf').factory('components', [
  '$filter', 'ImageUtils', 'FILE_TYPES',
  function ($filter, ImageUtils, FILE_TYPES) {

    return createPdfComponents({
      extractFileName: (filename) => $filter('filename')(filename) || '',
      formatDate: (date) => $filter('date')(date, 'mediumDate') || '',
      fileTypes: FILE_TYPES,
      imageUtils: ImageUtils
    });
  }
]);
